import { render, staticRenderFns } from "./fittings.vue?vue&type=template&id=55b022f0&"
import script from "./fittings.vue?vue&type=script&lang=js&"
export * from "./fittings.vue?vue&type=script&lang=js&"
import style0 from "./fittings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports